import React from 'react';

import {observer} from 'mobx-react';
import styles from "../styles/website.module.scss";
import classNames from "classnames";
import {AD_DISPLAYS} from "../../../core/consts";
import {
  ImportantInformationStripModuleAsync
} from "../../../modules/important-information-strip-module/components/important-information-strip-module.async";
import classnames from "classnames";
import {ExternalAd} from "../../../core/components/ad/external-ad/external-ad";

export const WebsiteModuleMainTop = observer(({controller}) => {
  const {device, state} = controller;
  const {isSmallView} = device;
  const {
    userCountryId,
    webPage,
    hasStripLinks,
    shouldRenderAd,
    externalAdConfig,
    isAllScores
  } = state;

  const adProps = {
    countryId: userCountryId,
    webPage,
    isSmallView,
    controller,
    isMock: state.appState.settings.config.adDisplay === AD_DISPLAYS.placeholders,
  }

  const externalAdProps = {
    ...adProps,
    config: externalAdConfig,
    className: classNames(styles.ad),
  }

  return (
    <div
      className={classnames(styles.main_top_container, {[styles.ad_strip]: shouldRenderAd && hasStripLinks && !isSmallView})}>
      {
        isAllScores ? <ImportantInformationStripModuleAsync/> : null
      }
      {
        shouldRenderAd ? <ExternalAd {...externalAdProps}/> : null
      }
    </div>
  );
});
